module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-03.66f37ba5.svg";